export var PBRRenderQuality;
(function (PBRRenderQuality) {
    PBRRenderQuality[PBRRenderQuality["High"] = 0] = "High";
    PBRRenderQuality[PBRRenderQuality["Low"] = 1] = "Low";
})(PBRRenderQuality || (PBRRenderQuality = {}));
